import { transactionSlice } from './slice'

/* Finalize Paypal Payment List Reducers */
export const { setFinalizePaypalPaymentLoading } = transactionSlice.actions
export const { setFinalizePaypalPaymentSuccess } = transactionSlice.actions
export const { setFinalizePaypalPaymentError } = transactionSlice.actions
export const { resetFinalizePaypalPaymentState } = transactionSlice.actions
